export default __webpack_public_path__ + "static/media/curlyBraces.2c3e843f.svg";